import React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { CmsEntities } from 'client/data/models/cms';

import { EditorCard } from './editor-card';
import './editors-list.scss';

export function EditorsList({ editorsSection }) {
  const { title } = editorsSection;
  const editors = editorsSection.children();

  return (
    <section className="editors-section editors-list">
      <h2 className="size-48 fw-bold mb-3_5">{title}</h2>
      <Row className="list-row">
        {editors.map(editor => (
          <Col xs={12} md={6} key={editor.id} className="px-2_5">
            <EditorCard editor={editor} />
          </Col>
        ))}
      </Row>
    </section>
  );
}

EditorsList.propTypes = {
  editorsSection: CmsEntities.Content.isRequired,
};
